var App = App || {};

App.SearchResults = (function ($) {
    'use strict';

    function init() {

        if ($(".widget.widget-search").length) {
            if (window.location.search.indexOf("search=") != -1) {
                $("html, body").animate({ scrollTop: $(".widget.widget-search").offset().top }, 200);
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SearchResults.init();
});